// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Register_wrapper__EpELY .Register_title__3rnlD {
  font-size: 48px;
  font-weight: 700;
  font-style: normal;
  color: #FFFFFF;
  text-align: center;
}
.Register_wrapper__EpELY .Register_firstRow__MFXSB {
  margin-top: 24px;
}
.Register_wrapper__EpELY .Register_errorMessage__EBGMY {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  color: #F44336;
  margin-top: 16px;
  text-align: center;
}
.Register_wrapper__EpELY .Register_row__a2STw {
  margin-bottom: 20px;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_label__7o2rh {
  color: #ffffff;
  margin-bottom: 12px;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_label__7o2rh span {
  color: #F44336;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_input__yxhSk {
  align-items: center;
  background-color: rgba(220, 220, 220, 0.1);
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  height: 56px;
  padding-left: 12px;
  padding-right: 12px;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_input__yxhSk .Register_inputWrapper__HkxFH {
  width: 100%;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_input__yxhSk .Register_inputWrapper__HkxFH input {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  background-color: unset;
  border: unset;
  color: #E0E0E0;
  outline: unset;
  width: 100%;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_input__yxhSk .Register_inputWrapper__HkxFH input::placeholder {
  color: #E0E0E0;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_input__yxhSk .Register_eye__qpIsq {
  align-items: center;
  cursor: pointer;
  display: flex;
  transition: all 0.2s linear;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_input__yxhSk .Register_eye__qpIsq svg path {
  fill: #E0E0E0;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_input__yxhSk .Register_eye__qpIsq:hover svg path {
  fill: #ffffff;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_inputFocus__xrxS4 {
  border: 1px solid #FD4C0A;
  transition: all 0.2s linear;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_condition__WiJlb {
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
  margin-top: 8px;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_condition__WiJlb .Register_conditionItem__pT1As {
  align-items: center;
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_offer__raWTb {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  align-items: center;
  background-color: rgba(220, 220, 220, 0.1);
  border-radius: 8px;
  color: #E0E0E0;
  display: flex;
  gap: 10px;
  height: 56px;
  justify-content: space-between;
  margin-top: 20px;
  padding-left: 16px;
  padding-right: 16px;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_offer__raWTb span {
  color: #EAD40C;
  cursor: pointer;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_offer__raWTb label {
  cursor: pointer;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_offer__raWTb label input {
  display: none;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_btn__WOgJ7 {
  margin-top: 24px;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_btn__WOgJ7 button {
  width: 100%;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_enter__ao2C8 {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  margin-top: 32px;
  text-align: center;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_enter__ao2C8 span {
  color: #EAD40C;
  cursor: pointer;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_error__fZgc4 {
  border: 1px solid #F44336;
}
.Register_wrapper__EpELY .Register_row__a2STw .Register_errorTxt__gIDhb {
  color: #F44336;
}
.Register_wrapper__EpELY .Register_regOffer__Ig6CL {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
  line-height: 150%;
  text-align: center;
}
.Register_wrapper__EpELY .Register_regOfferBtn__UnGx2 {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  color: #FD4C0A;
  cursor: pointer;
  text-align: center;
  text-decoration: underline;
}
.Register_wrapper__EpELY .Register_rowLast__dDwg3 {
  margin-bottom: 0;
}

@media (max-width: 850px) {
  .Register_wrapper__EpELY {
    width: 100%;
  }
  .Register_wrapper__EpELY .Register_title__3rnlD {
    font-size: 32px;
  }
  .Register_wrapper__EpELY .Register_row__a2STw .Register_condition__WiJlb {
    font-size: 14px;
  }
  .Register_wrapper__EpELY .Register_row__a2STw .Register_offer__raWTb {
    font-size: 14px;
  }
  .Register_wrapper__EpELY .Register_row__a2STw .Register_enter__ao2C8 {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/Register/Register.module.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_mixins.scss","webpack://./src/assets/styles/_colors.scss"],"names":[],"mappings":"AAIE;ECGA,eAAA;EACA,gBAAA;EACA,kBAAA;EDFE,cAAA;EACA,kBAAA;AAFJ;AAME;EACE,gBAAA;AAJJ;AAOE;EC6CA,eAAA;EACA,gBAAA;EACA,kBAAA;ED5CE,cAAA;EACA,gBAAA;EACA,kBAAA;AAJJ;AAOE;EACE,mBAAA;AALJ;AAOI;EACE,cAAA;EACA,mBAAA;AALN;AAOM;EACE,cAAA;AALR;AASI;EACE,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAPN;AASM;EACE,WAAA;AAPR;AASQ;ECYN,eAAA;EACA,gBAAA;EACA,kBAAA;EDXQ,uBAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;AANV;AAQU;EACE,cAAA;AANZ;AAWM;EACE,mBAAA;EACA,eAAA;EACA,aAAA;EACA,2BAAA;AATR;AAYU;EACE,aAAA;AAVZ;AAcQ;EACE,aAAA;AAZV;AAiBI;EE9CF,yBAAA;EACA,2BAAA;AFgCF;AAiBI;ECnBF,eAAA;EACA,gBAAA;EACA,kBAAA;EDoBI,cAAA;EACA,eAAA;AAdN;AAgBM;EACE,mBAAA;EACA,aAAA;EACA,QAAA;EACA,kBAAA;AAdR;AAkBI;ECvCF,eAAA;EACA,gBAAA;EACA,kBAAA;EDwCI,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAfN;AAiBM;EACE,cAAA;EACA,eAAA;AAfR;AAkBM;EACE,eAAA;AAhBR;AAkBQ;EACE,aAAA;AAhBV;AAqBI;EACE,gBAAA;AAnBN;AAqBM;EACE,WAAA;AAnBR;AAuBI;ECpGF,eAAA;EACA,gBAAA;EACA,kBAAA;EDqGI,cAAA;EACA,gBAAA;EACA,kBAAA;AApBN;AAsBM;EACE,cAAA;EACA,eAAA;AApBR;AAwBI;EACE,yBAAA;AAtBN;AAyBI;EACE,cAAA;AAvBN;AA2BE;EClGA,eAAA;EACA,gBAAA;EACA,kBAAA;EDmGE,cG5JW;EH6JX,iBAAA;EACA,kBAAA;AAxBJ;AA2BE;EC1GA,eAAA;EACA,gBAAA;EACA,kBAAA;ED2GE,cGjKO;EHkKP,eAAA;EACA,kBAAA;EACA,0BAAA;AAxBJ;AA2BE;EACE,gBAAA;AAzBJ;;AA6BA;EACE;IACE,WAAA;EA1BF;EA4BE;IACE,eAAA;EA1BJ;EA+BI;IACE,eAAA;EA7BN;EAgCI;IACE,eAAA;EA9BN;EAiCI;IACE,eAAA;EA/BN;AACF","sourcesContent":["@import '../../../assets/styles/global.scss';\n\n.wrapper {\n\n  .title {\n    @include h2;\n\n    color: #FFFFFF;\n    text-align: center;\n  }\n\n\n  .firstRow {\n    margin-top: 24px;\n  }\n\n  .errorMessage {\n    @include body1;\n\n    color: #F44336;\n    margin-top: 16px;\n    text-align: center;\n  }\n\n  .row {\n    margin-bottom: 20px;\n\n    .label {\n      color: #ffffff;\n      margin-bottom: 12px;\n\n      span {\n        color: #F44336;\n      }\n    }\n\n    .input {\n      align-items: center;\n      background-color: rgba(220, 220, 220, .1);\n      border-radius: 8px;\n      display: flex;\n      justify-content: space-between;\n      height: 56px;\n      padding-left: 12px;\n      padding-right: 12px;\n\n      .inputWrapper {\n        width: 100%;\n\n        input {\n          @include body1;\n\n          background-color: unset;\n          border: unset;\n          color: #E0E0E0;\n          outline: unset;\n          width: 100%;\n\n          &::placeholder {\n            color: #E0E0E0;\n          }\n        }\n      }\n\n      .eye {\n        align-items: center;\n        cursor: pointer;\n        display: flex;\n        transition: all .2s linear;\n\n        svg {\n          path {\n            fill: #E0E0E0;\n          }\n        }\n\n        &:hover svg path {\n          fill: #ffffff;\n        }\n      }\n    }\n\n    .inputFocus {\n      @include borderYellow;\n    }\n\n    .condition {\n      @include body2;\n\n      color: #E0E0E0;\n      margin-top: 8px;\n\n      .conditionItem {\n        align-items: center;\n        display: flex;\n        gap: 4px;\n        margin-bottom: 4px;\n      }\n    }\n\n    .offer {\n      @include body1;\n\n      align-items: center;\n      background-color: rgba(220, 220, 220, .1);\n      border-radius: 8px;\n      color: #E0E0E0;\n      display: flex;\n      gap: 10px;\n      height: 56px;\n      justify-content: space-between;\n      margin-top: 20px;\n      padding-left: 16px;\n      padding-right: 16px;\n\n      span {\n        color: #EAD40C;\n        cursor: pointer;\n      }\n\n      label {\n        cursor: pointer;\n\n        input {\n          display: none;\n        }\n      }\n    }\n\n    .btn {\n      margin-top: 24px;\n\n      button {\n        width: 100%;\n      }\n    }\n\n    .enter {\n      @include subtitle4m;\n\n      color: #ffffff;\n      margin-top: 32px;\n      text-align: center;\n\n      span {\n        color: #EAD40C;\n        cursor: pointer;\n      }\n    }\n\n    .error {\n      border: 1px solid #F44336;\n    }\n\n    .errorTxt {\n      color: #F44336;\n    }\n  }\n\n  .regOffer {\n    @include body1;\n\n    color: $c-light-grey;\n    line-height: 150%;\n    text-align: center;\n  }\n\n  .regOfferBtn {\n    @include body1;\n\n    color: $c-yellow;\n    cursor: pointer;\n    text-align: center;\n    text-decoration: underline;\n  }\n\n  .rowLast {\n    margin-bottom: 0;\n  }\n}\n\n@media (max-width: 850px) {\n  .wrapper {\n    width: 100%;\n\n    .title {\n      font-size: 32px;\n    }\n\n    .row {\n\n      .condition {\n        font-size: 14px;\n      }\n\n      .offer {\n        font-size: 14px;\n      }\n\n      .enter {\n        font-size: 16px;\n      }\n    }\n  }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n","@mixin df {\n  display: flex;\n}\n\n@mixin df-aic {\n  align-items: center;\n  display: flex;\n}\n\n@mixin df-aic-g8 {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n}\n\n@mixin df-aic-jcc {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n@mixin df-aic-jcsb {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n@mixin hoverYellow {\n  transition: all .2s linear;\n\n  &:hover {\n    color: $c-yellow;\n  }\n}\n\n@mixin borderYellow {\n  border: 1px solid $c-yellow;;\n  transition: all .2s linear;\n}","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #FD4C0A;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Register_wrapper__EpELY`,
	"title": `Register_title__3rnlD`,
	"firstRow": `Register_firstRow__MFXSB`,
	"errorMessage": `Register_errorMessage__EBGMY`,
	"row": `Register_row__a2STw`,
	"label": `Register_label__7o2rh`,
	"input": `Register_input__yxhSk`,
	"inputWrapper": `Register_inputWrapper__HkxFH`,
	"eye": `Register_eye__qpIsq`,
	"inputFocus": `Register_inputFocus__xrxS4`,
	"condition": `Register_condition__WiJlb`,
	"conditionItem": `Register_conditionItem__pT1As`,
	"offer": `Register_offer__raWTb`,
	"btn": `Register_btn__WOgJ7`,
	"enter": `Register_enter__ao2C8`,
	"error": `Register_error__fZgc4`,
	"errorTxt": `Register_errorTxt__gIDhb`,
	"regOffer": `Register_regOffer__Ig6CL`,
	"regOfferBtn": `Register_regOfferBtn__UnGx2`,
	"rowLast": `Register_rowLast__dDwg3`
};
export default ___CSS_LOADER_EXPORT___;
